export const RESET = "RESET";

export const SET_ARTICLE_NUMBER = "SET_ARTICLE_NUMBER";

export const SET_REMOTE_DATA = "SET_REMOTE_DATA";
